import useFeedbackAPIClient from "../../api/feedback/hooks/useFeedbackAPIClient";

const useSubmitBugReport = () => {
  const { submitBugReport } = useFeedbackAPIClient();

  const submit = async ({ whatHappened, ...rest }) => {
    try {
      if (!whatHappened) {
        return {
          success: false,
          error:
            "You must at least describe what happened. The more information you can provide, the better chance we have of fixing the issue.",
        };
      }

      const response = await submitBugReport({
        whatHappened,
        ...rest,
      });

      if (response.ok) {
        return { success: true };
      } else {
        const errorData = await response.json();
        return {
          success: false,
          error: errorData.message || "Failed to submit bug report",
        };
      }
    } catch (error) {
      console.error("Error submitting bug report:", error);
      return { success: false, error: error.message };
    }
  };

  return { submit };
};

export default useSubmitBugReport;
